import Project from '@/views/project/project.view.vue';

export default [
  {
    path: '/:projectName/home',
    name: 'project',
    component: Project,
  },
];
